import { ButtonVariant, IStepProps, IStepsProps, StepsOrientation, StepsType } from '@amobee/component-library';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { CampaignAdapter } from 'src/adapters/campaign-adapter';
import { CreativeAdapter } from 'src/adapters/creative-adapter';
import { MiscAdapter } from 'src/adapters/misc-adapter';
import { IFooterProp } from 'src/app/common/components/footer/footer.component';
import { CampaingStatusSteps } from 'src/app/data/constants/campaign-status-steps';
import { CampaignStatus } from 'src/app/data/constants/campaign-status.const';
import { Constants } from 'src/app/data/constants/constants.enum';
import { CreativeProductIdMap } from 'src/app/data/constants/creative-produce.const';
import { CreativeProductIdPrice } from 'src/app/data/constants/creative-productid-price.enum';
import { GoalType } from 'src/app/data/constants/goal-type.const';
import { MediaPlanStatus } from 'src/app/data/constants/mediaplan-status.const';
import { OrderStatus } from 'src/app/data/constants/orderStatus.enum';
import { PaymentOverallStatus } from 'src/app/data/constants/payment-status.enum';
import { PaymentType } from 'src/app/data/constants/payment-type.const';
import { CampaignVO } from 'src/app/data/vo/CampaignVO';
import { CreativeVO } from 'src/app/data/vo/CreativeVO';
import { MediaPlanVO } from 'src/app/data/vo/MediaPlanVO';
import { NameValuePairVO } from 'src/app/data/vo/NameValuePairVO';
import { OrderVO } from 'src/app/data/vo/OrderVO';
import { PricingSummaryVO } from 'src/app/data/vo/PricingSummaryVO';
import { downloadExcelFile } from 'src/app/misc/util/util';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { MessageService } from 'src/app/services/message.service';
import { ModalService } from 'src/app/services/modal.service';
import { PaymentService } from 'src/app/services/payment.service';
import { environment } from 'src/environments/environment';
import { CampaignOrder, PlanCreationData } from 'src/whiteLabel/mediaCorps/services/campaign/campaign-data';

@Component({
  selector: 'campaign-summary',
  templateUrl: './campaign-summary.component.html',
  styleUrls: ['./campaign-summary.component.scss']
})
export class CampaignSummaryComponent implements OnInit {

  campaignVO: CampaignVO;
  planCreationData: PlanCreationData;
  formTitle: string;
  //Todo: add a constant file once all campaign statues are known
  stepsConfig: IStepsProps = {
    type: StepsType.ICON,
    orientation: StepsOrientation.HORIZONTAL
  }
  warningIcon: IStepProps['warningIcon'] = 'Time';
  stepsObject: { steps: Array<IStepProps>; completedStep: IStepsProps['completedStep'] };
  goal: string;
  buyerCreative: Array<CreativeVO> = [];
  sellerCreative: Array<CreativeVO> = [];
  unpaidCreativeIds: Array<number>;
  platform = environment.platform;
  CreativeProductPrice = CreativeProductIdPrice;
  campaignBudgetSize: number = Constants.CAMPAIGN_BUDGET_SIZE;
  isBudgetAboveSize: boolean;
  mediaPlanStatus: string;
  isLoadingMediaPlanBlob: boolean;
  paymentDone: boolean = false;
  status: string;
  CampaignStatus = CampaignStatus;
  MediaPlanStatus = MediaPlanStatus;
  paymentType: string;
  currencySymbol: string = environment.currency;
  currencyShortSymbol: string = environment.currencySymbol;
  pricingSummary: PricingSummaryVO;
  gst: number = environment.gst;
  lastPaymentDate: Date;
  languages: Array<string> = [];
  channels: Array<string> = [];
  timezoneStr: string = environment.timezone;
  timezoneAbbrStr: string = environment.timezoneAbbr;
  orderId: string;
  nonCancelledOrder: Array<OrderVO> = [];
  footerButtons: Array<IFooterProp> = [
    {
      variant: ButtonVariant.NEUTRAL,
      label: 'View Campaign Details',
      onClick: () => {
        this.viewCampaignDetails();
      }
    },
    {
      variant: ButtonVariant.NEUTRAL,
      label: 'All Campaigns',
      onClick: () => {
        this.allCampaigns();
      }
    },
    {
      variant: ButtonVariant.NEUTRAL,
      label: 'Start Over',
      isActive: () => this.isBudgetAboveSize && this.mediaPlanStatus === this.MediaPlanStatus.REVIEW.key,
      onClick: () => {
        this.startOver();
      }
    },
    {
      variant: ButtonVariant.PRIMARY,
      label: 'Order Media Plan',
      isActive: () => this.isBudgetAboveSize && this.mediaPlanStatus === this.MediaPlanStatus.REVIEW.key && !this.paymentDone,
      onClick: () => {
        if (this.paymentType === PaymentType.CreditCard.key || this.paymentType === PaymentType.MediacorpCredit.key) {
          this.orderMediaPlan();
        } else {
          this.modal.error({ message: 'Please Select Payment type to proceed' });
        }
      }
    },
    {
      variant: ButtonVariant.PRIMARY,
      label: 'Accept Media Plan',
      isActive: () => this.isBudgetAboveSize && this.mediaPlanStatus === this.MediaPlanStatus.REVIEW.key && this.paymentDone,
      onClick: () => {
        this.updateMediaPlanStatus(MediaPlanStatus.APPLIED.key);
      }
    }
  ];
  creativeDescriptions: Array<any> = [];
  creativeProductIdMap = CreativeProductIdMap;
  appliedDiscountCode: string;
  enableDiscountFeature: boolean = environment.enableDiscountFeature;
  @ViewChild('paymentSuccessModel', { static: true }) public paymentSuccessModel: TemplateRef<any>;
  @ViewChild('paymentPendingTemplate', { static: true }) public paymentPendingTemplate: TemplateRef<any>;

  constructor(
    private router: Router,
    private modal: ModalService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private campaignAdapter: CampaignAdapter,
    private paymentService: PaymentService,
    private breadcrumbService: BreadcrumbService,
    private creativeAdapter: CreativeAdapter,
    private miscAdapter: MiscAdapter) {
  }

  ngOnInit() {

    this.messageService.sendFormTitle(['Review and Select Media Plan', true]);

    let data = this.route.snapshot.data;
    if (data.campaignData) {
      this.campaignVO = data.campaignData[0];
      if (this.campaignVO.status === CampaignStatus.Draft.key) {
        this.router.navigate(['campaign', 'edit', this.campaignVO.id]);
      } else {
        this.campaignVO.creatives = data.campaignData[1];
        let campaignOrders: OrderVO[] = data.campaignData[2];
        if (campaignOrders) {
          this.nonCancelledOrder = _.filter(campaignOrders, o => o.status !== OrderStatus.CANCELLED && o.status !== OrderStatus.FAILED);
          campaignOrders.forEach((order: OrderVO) => {
            if (order.status === OrderStatus.PAID) {
              // find one order with PAID status
              this.pricingSummary = order;
              // seller creatives will be defined below
              setTimeout(() => this.getNotPaidCreatives(), 0);
              this.paymentDone = true;
            }
          });
        }
        this.isBudgetAboveSize = this.campaignVO.budget >= this.campaignBudgetSize;
        this.campaignAdapter.getCampaignMediaPlan(this.route.snapshot.params.campaignId).then(resp => {
          if (resp && resp.length > 0) {
            let plan = resp.find((mpVO: MediaPlanVO) => mpVO.status === MediaPlanStatus.APPROVED.key || mpVO.status === MediaPlanStatus.APPLIED.key || mpVO.status === MediaPlanStatus.REVIEW.key);
            if (!plan) {
              // if there is no valid plan, pick the uploaded or the first one still
              plan = resp[0];
            }
            this.campaignVO.mediaPlan = plan;
          }
          if (this.campaignVO.mediaPlan) {
            this.mediaPlanStatus = this.campaignVO.mediaPlan.status;
            if (!this.isBudgetAboveSize || this.mediaPlanStatus === MediaPlanStatus.APPLIED.key || this.mediaPlanStatus === MediaPlanStatus.APPROVED.key || (this.isBudgetAboveSize && this.mediaPlanStatus === MediaPlanStatus.REVIEW.key)) {
              //TODO: Need to decide how to set last Payment date.
              // this.campaignAdapter.getCampaignPaymentDetail(this.campaignVO.id).then((paymentDetail: CampaignCreativePaymentDetail) => {
              //   if (paymentDetail && paymentDetail.payments) {
              //     paymentDetail.payments.forEach((v) => {
              //       if (v.status === PaymentStatus.SUCCESS) {
              //         this.paymentDone = true;
              //         // check the last success payment date
              //         let paymentDate = new Date(v.transactionTimestamp);
              //         if (!this.lastPaymentDate || this.lastPaymentDate.getTime() < paymentDate.getTime()) {
              //           this.lastPaymentDate = paymentDate;
              //         }
              //       }
              //     });
              //   }
              // });
              // if no PAID order found previously, get pricing summary by the its own api
              if (!this.pricingSummary) {
                this.getCampaignPricingSummary();
              }
            }
          }
          this.campaignAdapter.getCampaignStepperProps(this.campaignVO).then((value) => {
            this.stepsObject = value;
          });
        });

        if (this.campaignVO.planId) {
          this.campaignAdapter.getPlan(this.campaignVO.planId).then((response: PlanCreationData) => {
            this.planCreationData = response;
            this.campaignAdapter.isMultiAdvertiser().then(((isMultiAdvertiser: boolean) => {
              if (isMultiAdvertiser) {
                this.breadcrumbService.prepareBreadcrumb(this.planCreationData.customer_id, this.planCreationData.advertiser_id, this.planCreationData.brand_id);
                this.campaignAdapter.updateCBAId(this.planCreationData.customer_id, this.planCreationData.advertiser_id, this.planCreationData.brand_id);
              }
            }));
          });
        }
      }
    }
    //-TODO-
    // if (this.status === this.CampaignStatus.Draft.key) {
    //   this.redirectToListPage();
    // }

    this.campaignAdapter.getCustomerId().then((cid) => {
      this.miscAdapter.isCreditAccountNumberApproved(cid.toString()).then((r) => {
        this.paymentType = r ? PaymentType.MediacorpCredit.key : PaymentType.CreditCard.key;
      }).catch((err) => {
        console.log(err);
        this.paymentType = PaymentType.CreditCard.key;
      });
    });

    this.campaignAdapter.getLanguages(this.campaignVO.startDate, this.campaignVO.endDate).then((languages: NameValuePairVO[]) => {
      this.languages = _.map(_.filter(languages, lan => _.findIndex(this.campaignVO.languages, ln => ln === lan.value) > -1), 'name');
    });
    this.campaignAdapter.getChannels(this.campaignVO.startDate, this.campaignVO.endDate).then((channels: NameValuePairVO[]) => {
      this.channels = _.map(_.filter(channels, chnl => _.findIndex(this.campaignVO.channels, ch => ch === chnl.value) > -1), 'name');
    });

    this.campaignAdapter.getTargetedAudienceSize(this.campaignVO.id, this.campaignVO.segment, this.campaignVO.gender, this.campaignVO.age).then(targetedAudienceSize => {
      this.campaignVO.audienceSize = targetedAudienceSize;
    });

    if (this.campaignVO.goalType) {
      this.goal = GoalType[this.campaignVO.goalType].label;
    }

    this.buyerCreative = _.filter(this.campaignVO.creatives, { creativeAuthor: 'Buyer' });
    this.sellerCreative = _.filter(this.campaignVO.creatives, { creativeAuthor: 'Seller' });
  }

  onPaymentSelection(type: string) {
    if (type !== this.paymentType) {
      this.paymentType = type;
    }
  }

  public viewCampaignDetails(): void {
    this.router.navigate(['campaign/edit', this.route.snapshot.params.campaignId], { queryParams: { readOnly: true } });
  }

  public allCampaigns(): void {
    this.redirectToListPage();
  }

  private redirectToListPage(): void {
    this.router.navigate(["campaign"]);
  }

  public startOver(): void {
    this.router.navigate(['campaign/new']);
  }

  public orderMediaPlan(): void {
    if (this.pricingSummary) {
      if (this.paymentType === PaymentType.CreditCard.key || this.paymentType === PaymentType.MediacorpCredit.key) {
        let objType: string = Constants.CAMPAIGN;
        let unpaidCreativeIds: number[];
        if (this.pricingSummary.creativesCost && _.size(this.pricingSummary.creativesCost.creatives)) {
          objType = Constants.CAMPAIGNANDMEDIA;
          unpaidCreativeIds = this.pricingSummary.creativesCost.creatives.map(v => v.creativeId);
        }
        let pro: Array<Promise<any>> = [];
        if (_.size(this.nonCancelledOrder)) {
          _.forEach(this.nonCancelledOrder, no => {
            pro.push(this.miscAdapter.patchPaymentStatus(no.orderId, OrderStatus.CANCELLED).then(() => {
              this.nonCancelledOrder = _.remove(this.nonCancelledOrder, { orderId: no.orderId });
            }));
          });
        }
        Promise.all(pro).then(() => {
          this.paymentService.order(this.pricingSummary.grandTotalCost, environment.currency, objType, [this.campaignVO.id], unpaidCreativeIds, this.paymentType, this.pricingSummary.discountCodeId)
            .then((campaignOrder: CampaignOrder) => {
              this.orderId = campaignOrder.order_id;
              this.setUpPaymentStatusCheck();
            }).catch((err) => {
              console.log(err)
              this.modal.error({ message: 'Failed to process payment, please try again' });
            });
        })


      } else {
        this.modal.error({ message: 'Please Select Payment type to proceed' });
      }
    } else {
      this.modal.error({ message: 'Failed to get pricing summary of the campaign' });
    }
  }

  setUpPaymentStatusCheck() {
    let closeModal = this.modal.openModal({
      closeButton: false,
      headerContent: 'Thank you!',
      bodyContent: this.paymentPendingTemplate,
      hideFooterContent: true,
      disabledNonFooterClick: true
    });
    let interval = setInterval(() => {
      this.campaignAdapter.getOrder(this.orderId).then((payments: CampaignOrder) => {
        if (payments.status === 'PAID') {
          this.paymentDone = true;
          clearInterval(interval);
          this.updateMediaPlanStatus(MediaPlanStatus.APPLIED.key, closeModal);
        }
      });
    }, Constants.PAYMENT_STATUS_CHECK_INTERVAL);
  }

  updateMediaPlanStatus(status: string, closeModal?: any) {
    this.campaignAdapter.updateMediaPlanStatus(this.campaignVO.id, this.campaignVO.mediaPlan.id, status).then((resp) => {
      console.log('Media plan status updated: ' + resp);
      if (closeModal) {
        closeModal(false);
      }
      // case for budget > 100K, 3rd step is media plan, 4th step is payment
      // mark payment as completed, and mark media plan as accept
      this.stepsObject.steps[2].label = CampaingStatusSteps.MediaPlanAccepted;
      this.stepsObject.steps[2].warning = false;
      this.stepsObject.completedStep = 4;
      this.modal.confirmation(this.paymentSuccessModel,
        'Payment Accepted', '', undefined, undefined,
        [{
          label: 'Ok',
          variant: ButtonVariant.PRIMARY
        }]
      );
      this.redirectToListPage();
    }, error => {
      console.log(error);
      if (closeModal) {
        closeModal(false);
      }
      this.modal.error({
        message: 'There were some errors while trying to accept the media plan after payment received, please contact administrator for helps'
      });
    });
  }

  downloadMediaPlan() {
    this.isLoadingMediaPlanBlob = true;
    this.campaignAdapter.downloadMediaPlan(this.campaignVO.id, this.campaignVO.mediaPlan.id).then((resp: Blob) => {
      let fileName = this.campaignVO.mediaPlan.downloadFileName;
      if (fileName.split('.').pop() === 'zip') {
        fileName = fileName.split('.zip').shift() + '.xlsx';
      }
      downloadExcelFile(resp, fileName);
      console.log("Mediaplan downloaded");
    }).finally(() => {
      this.isLoadingMediaPlanBlob = false;
    });
  }

  getNotPaidCreatives() {
    if (this.sellerCreative && this.sellerCreative.length && this.pricingSummary.creativesCost &&
      this.pricingSummary.creativesCost.creatives && this.pricingSummary.creativesCost.creatives.length) {
      let creativeIdBudgetMap = {};
      let creativeProductIdCount = {};

      this.pricingSummary.creativesCost.creatives.forEach((v) => {
        creativeIdBudgetMap[v.creativeId] = v.budget;
      });
      this.sellerCreative.forEach((cvo) => {
        if (creativeIdBudgetMap[cvo.creativeId]) {
          // unpaid creative
          if (!creativeProductIdCount[cvo.creative_product_id]) {
            creativeProductIdCount[cvo.creative_product_id] = {
              type: this.creativeProductIdMap[cvo.creative_product_id].type,
              cost: 0,
              quantity: 0
            };
          }
          creativeProductIdCount[cvo.creative_product_id].cost += creativeIdBudgetMap[cvo.creativeId];
          creativeProductIdCount[cvo.creative_product_id].quantity++;
        }
      });
      this.creativeDescriptions = Object.values(creativeProductIdCount);
    }
  }

  getCampaignPricingSummary(code?: string) {
    let promise = Promise.resolve();
    if (!this.unpaidCreativeIds) {
      if (this.sellerCreative.length) {
        let creativeIds = this.sellerCreative.map((cvo) => cvo.creativeId);
        promise = this.creativeAdapter.getCreativesPaymentStatus(creativeIds).then((creativeStatus) => {
          this.unpaidCreativeIds = [];
          creativeStatus.forEach((cs) => {
            if (cs.status === PaymentOverallStatus.NOT_PAID) {
              this.unpaidCreativeIds.push(cs.creativeId);
            }
          })
        });
      } else {
        this.unpaidCreativeIds = [];
      }
    }
    return promise.then(() => {
      return this.campaignAdapter.getCampaignPricingSummary(this.campaignVO.id, this.unpaidCreativeIds, code, this.campaignVO.budget < this.campaignBudgetSize ? this.campaignVO.mediaPlanOption : undefined).then((summary: PricingSummaryVO) => {
        this.pricingSummary = summary;
        this.getNotPaidCreatives();
      });
    })
  }

  onCodeChange(code: string) {
    this.getCampaignPricingSummary(code).then(() => {
      this.appliedDiscountCode = code;
    }, (e) => {
      this.appliedDiscountCode = '';
    });
  }

}
